interface StatCardProps {
  label: string;
  value: string | number;
  sub?: string;
  variant?: 'default' | 'profit' | 'loss' | 'warn' | 'info';
}

const variantColors = {
  default: 'text-white',
  profit: 'text-trader-profit',
  loss: 'text-trader-loss',
  warn: 'text-trader-warn',
  info: 'text-trader-info',
};

export default function StatCard({ label, value, sub, variant = 'default' }: StatCardProps) {
  return (
    <div className="bg-trader-card border border-trader-border rounded-lg p-4">
      <p className="text-xs text-trader-muted uppercase tracking-wider mb-1">{label}</p>
      <p className={`text-2xl font-bold ${variantColors[variant]}`}>{value}</p>
      {sub && <p className="text-xs text-trader-muted mt-1">{sub}</p>}
    </div>
  );
}
